module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lYl8v"))).then(() => module.bundle.root('8rm4T'));